<template>
  <div class="flex items-center gap-2 text-sm" :class="textColor">
    <template v-for="(item, index) in items" :key="index">
      <router-link
        v-if="item.to"
        :to="item.to"
        class="p-1 hover:text-gray-900 transition-all duration-200"
        :class="{ 'blur-md select-none': item.blur }"
      >
        {{ item.label }}
      </router-link>
      <span
        v-else
        class="text-gray-900 cursor-default"
        :class="{ 'blur-md select-none': item.blur }"
      >
        {{ item.label }}
      </span>
      <span v-if="index < items.length - 1" class="cursor-default">></span>
    </template>
  </div>
</template>

<script setup lang="ts">
interface BreadcrumbItem {
  label: string
  to?: string
  blur?: boolean
}

interface Props {
  items: BreadcrumbItem[]
  textColor?: string
}

withDefaults(defineProps<Props>(), {
  textColor: 'text-gray-700'
})
</script>